import * as React from "react";
import type { SVGProps } from "react";
const SvgTowel = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M20.69 11.95A1.007 1.007 0 0 0 22 10.88l-.64-3.38C21.1 4.93 18.96 3 16.38 3H7.73c-2.61 0-4.8 2.04-4.98 4.62L2 12.9v2.6C2 18.53 4.47 21 7.5 21h9c3.03 0 5.5-2.47 5.5-5.5 0-1.35-.49-2.59-1.31-3.55Zm-1.32-4.23.64 3.4c0 .08.04.14.07.21A5.45 5.45 0 0 0 16.5 10H16V5h.38c1.55 0 2.83 1.16 2.99 2.72ZM12 5h2v5h-2V5Zm4.5 14h-9C5.57 19 4 17.43 4 15.5v-2.45l.74-5.26A3.002 3.002 0 0 1 7.73 5H10v5H8.5c-2.21 0-4 1.79-4 4s1.79 4 4 4H16a2.5 2.5 0 0 0 0-5H9c-.55 0-1 .45-1 1s.45 1 1 1h7c.28 0 .5.22.5.5s-.22.5-.5.5H8.5c-1.1 0-2-.9-2-2s.9-2 2-2h8c1.93 0 3.5 1.57 3.5 3.5S18.43 19 16.5 19Z"
    />
  </svg>
);
export default SvgTowel;
